<template>
  <div class="content">
    <div class="page-inner">
      <div class="page-header mb-0">
        <router-link to="/distributions">
          <i class="fa fa-chevron-left mr-1"></i>
          {{ $t('my_releases') }}
        </router-link>
      </div>

      <DistributionProgress :distribution="distribution" v-if="!fromMetadataPage"></DistributionProgress>

      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="store-title mb-2">
                {{ $t('basic_platforms') }}
              </div>
              <div class="features-list mt-3" v-html="$t('basic_platforms_descriptions')">
              </div>
              <div class="mt-3 mb-2">
                <div class="row">
                  <div class="col-4 mb-2">
                    <img width="100%" src="/static/img/stores-cms/spotify.png" alt="">
                  </div>
                  <div class="col-4 mb-2">
                    <img width="100%" src="/static/img/stores-cms/deezer.png" alt="">
                  </div>
                  <div class="col-4 mb-2">
                    <img width="100%" src="/static/img/stores-cms/youtube-music.png" alt="">
                  </div>
                </div>
              </div>
              <div class="text-right">
                {{ $t('included') }} <i class="fa fa-check text-success ml-1"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="store-title mb-2">
                <i class="fa fa-coins text-warning mr-1"></i> {{ $t('premium_platforms') }}
                <span class="pro-badge badge badge-primary">PRO</span>
              </div>
              <div>
                <div class="features-list mt-3" v-html="$t('pro_stores_description')">
                </div>
                <div class="mt-3 mb-3">
                  <div class="row">
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/tiktok.png" alt="">
                    </div>
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/apple-music.png" alt="">
                    </div>
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/amazon-music.png" alt="">
                    </div>
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/pandora.png" alt="">
                    </div>
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/meta.png" alt="">
                    </div>
                    <div class="col-4 mb-2">
                      <img width="100%" src="/static/img/stores-cms/soundcloud.png" alt="">
                    </div>
                  </div>
                  <p class="mt-1">
                    + {{ $t('plus_basic_and_more') }} <a class="ml-1" href="https://help.indiefy.net/hc/en-us/articles/360045732514-Which-stores-does-Indiefy-distribute-to-" target="_blank"><i class="fas fa-external-link-alt"></i></a>
                  </p>
                </div>
              </div>
              <div class="text-right mt-2">
                <div @click="toggleProStores($event)">
                  <input ref="deliverProToggle" type="checkbox" :id="`deliver_pro`" data-toggle="toggle" data-onstyle="primary" data-style="btn-round" class="toggle-checkbox dsp-checkbox">
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="store-title mb-2">
                <i class="fa fa-copyright text-success mr-1"></i> <span v-html="$t('youtube_content_id')"></span>
                <span class="pro-badge badge badge-primary">PRO</span>
              </div>
              <div class="mt-3" v-html="$t('content_id_description')">
              </div>
              <div class="text-right mt-3">
                <div @click="toggleContentId($event)">
                  <input ref="deliverContentId" type="checkbox" :id="`deliver_content_id`" data-toggle="toggle" data-onstyle="primary" data-style="btn-round" class="toggle-checkbox dsp-checkbox">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-action mt-3 mb-4" v-if="!fromMetadataPage">
        <div class="row">
          <div class="col-md-12 text-right">
            <router-link
              tag="button"
              :to="`/distributions/${distribution._id}/cover`"
              class="btn btn-border no-border"
              :disabled="sent"
            >
              <i class="fa fa-chevron-left mr-1"></i>
              {{ $t('back') }}
            </router-link>
            <button :disabled="sent" class="btn btn-gradient ml-1" @click="submitDistribution()">
              {{ $t('continue') }}
              <i class="fa fa-chevron-right ml-1"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- <div v-if="!user.subscription" class="text-center mb-3 mt-3">
        <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-8326584585992829"
            data-ad-slot="3934111543"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div> -->
    </div>
    <UpgradeModal></UpgradeModal>
  </div>
</template>
<script>
import moment from 'moment'
import Distributions from '../services/distributions'
import UpgradeModal from './utils/UpgradeModal'
import DistributionProgress from './utils/DistributionProgress'
import Public from '../services/public'

export default {
  name: 'DistributionStores',
  props: ['fromMetadataPage'],
  data: function () {
    return {
      deliverPro: false,
      name: 'DistributionStores',
      sent: false,
      isPro: false,
      user: {},
      lang: 'en',
      allSelected: false,
      distribution: {
        title: '',
        _id: ''
      },
      moment: moment,
      saving: false,
      loading: false
    }
  },
  methods: {
    initCheckboxes: function () {
      if (this.isPro && (this.distribution.pro_stores === 1 || this.distribution.pro_stores === null)) {
        this.$refs.deliverProToggle.checked = true
        this.distribution.pro_stores = 1
        this.deliverPro = true
      }

      if (this.isPro && (this.distribution.content_id === 1 || this.distribution.content_id === null)) {
        this.$refs.deliverContentId.checked = true
        this.distribution.content_id = 1
        this.deliverContentId = true
      }

      if (!this.isPro) {
        this.$refs.deliverProToggle.checked = false
        this.distribution.pro_stores = 0
        this.deliverPro = false
        this.$refs.deliverContentId.checked = false
        this.distribution.content_id = 0
        this.deliverContentId = false
      }
    },
    basicStoresRequired: function () {
      this.$notify({ message: this.$t('basic_platforms_needed') }, 'warning', 'fa-exclamation')
    },
    toggleContentId: function (event) {
      if (!this.isPro) {
        event.stopPropagation()
        return this.$eventBus.$emit('showUpgradeModal', '', 'content_id')
      }

      this.deliverContentId = !this.deliverContentId

      setTimeout(() => {
        this.$refs.deliverContentId.checked = this.deliverContentId
      }, 1)
    },
    toggleProStores: function (event) {
      if (!this.isPro) {
        event.stopPropagation()
        return this.$eventBus.$emit('showUpgradeModal', '', 'pro_stores')
      }

      this.deliverPro = !this.deliverPro

      setTimeout(() => {
        this.$refs.deliverProToggle.checked = this.deliverPro
      }, 1)
    },
    submitDistribution: function () {
      if (this.user.subscription && this.user.subscription.plan_name !== 'indiefy_lite') {
        this.distribution.pro_stores = this.deliverPro
        this.distribution.preorder = 1
        this.distribution.content_id = this.deliverContentId
      }

      this.sent = true
      this.distribution.fromPage = 'stores'
      this.distribution.steps.step_stores = { validate: true }

      Distributions.save(this.distribution).then(() => {
        return this.$router.push(`/distributions/${this.$route.params.id}/review`)
      }).catch(err => {
        let error = err.response.data.name

        if (error === 'release_date_invalid') {
          this.$notify(
            { message: this.$t('release_date_invalid') },
            'danger',
            'fa-exclamation'
          )
        }
        if (error === 'distro_already_reviewed') {
          if (this.$route.params.id) {
            this.$router.push(`/distributions/${this.$route.params.id}/details`)
          } else {
            this.$router.push(`/distributions`)
          }
        }
      })
    },
    getDistribution: function () {
      return Distributions.get(this.$route.params.id).then(response => {
        this.distribution = response.data
        this.initCheckboxes()

        setTimeout(() => {
          window.$('[data-toggle="tooltip"]').tooltip()
          window.$('.toggle-checkbox[data-toggle]').bootstrapToggle()
          window.scrollTo(0, 0)
        }, 200)
      })
    }
  },
  mounted: function () {
    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 100)
    // }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale

    if (this.user.subscription && this.user.subscription.plan_name === 'indiefy_pro') {
      this.isPro = true
    }

    this.loading = true

    if (this.$route.params.id) {
      this.getDistribution().then(() => {
        this.loading = false
      }).catch(() => {
        this.$router.push(`/distributions`)
      })
    }

    Public.getLocationSettings().then(responseSettings => {
      this.locationSettings = responseSettings.data

      if (this.locationSettings.hide_basic && !this.user.subscription) {
        return this.$router.push(`/upgrade?from=store_selector_location`)
      }
    })
  },
  components: {
    UpgradeModal,
    DistributionProgress
  }
}
</script>
<style lang="scss" scoped>
.pro-badge {
  position: absolute;
  right: -5px;
  top: -10px;
}
.modal-content-id-text {
  min-height: 75px;
}
.list-stores {
  li {
    span {
      display: inline-block;
      padding-top: 3px;
    }
  }
}

.pro-title {
  font-weight: 900;
  font-size: 28px;
  text-transform: uppercase;
}

.store-title {
  letter-spacing: 2px;
  text-transform: uppercase;
}

.price-big {
  font-weight: 900;
  font-size: 52px;
}

.disabled-checkbox .toggle.btn,
.disabled-checkbox:hover .toggle.btn {
  background: #c3c3c3 !important;
}

.checkall-content{
  display: inline-block;
  width: 100%;
  .checkall-left{
    display: inline-block;
  }
  .checkall-right{
    float: right;
    .switch-text{
      vertical-align: sub;
      padding-right: 10px;
    }
  }
}
.basic-stores {
  margin-top: 1rem !important;
}
.store-container {
  background: #ffffff;
  border-radius: 3px;
  margin-top: 15px;
  .list-elem, li {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    .img-store {
      height: 65px;
      padding: 8px;
      margin-right: 10px;
    }
    .name-store {
      display: block;
      flex-grow: 3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 15%;
    }
    .align-right {
      width: 62.3px;
    }
  }
}
.store-show-mobile {
  display: none !important;
}
.pre-order-container {
  padding-right: 0px;
  padding-left: 0px;
  .title {
    padding-left: 15px;
  }
}
.metadata-modified {
  box-shadow: 0px 0px 2px 0px #5714ff;
}
.special-guideline {
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  .stores-list-all {
    margin-right: -15px !important;
  }
  .checkall-content {
    .checkall-left {
      padding-bottom: 10px;
    }
    .checkall-right {
      padding-right: 17px;
      width: 100%;
      padding-left: 17px;
    }
  }
  .store-show-mobile {
    display: block !important;
  }
  .store-hide-mobile {
    display: none !important;
  }
  .pre-order-container {
    padding-right: 15px;
    padding-left: 15px;
    .title {
      padding-left: 0px;
    }
  }
  .basic-stores {
    margin-top: 0px !important;
  }
}

.features-list {
  li {
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionStores.vue